import type { RouteObject } from 'react-router-dom'

import { BackupScreen } from '../screens/backup/BackupScreen.js'
import { ExportScreen } from '../screens/export/ExportScreen.js'
import { InsightsScreen } from '../screens/insights/InsightsScreen.js'
import { ReportScreen } from '../screens/report/ReportScreen.js'
import { EntryFormScreen } from '../screens/log/EntryFormScreen.js'
import { HomeScreen } from '../screens/log/HomeScreen.js'
import { SettingsScreen } from '../screens/SettingsScreen.js'
import { TagsScreen } from '../screens/tags/TagsScreen.js'
import { EntryDetailScreen } from '../screens/timeline/EntryDetailScreen.js'
import { TimelineScreen } from '../screens/timeline/TimelineScreen.js'
import { TemplateEditorScreen } from '../screens/templates/TemplateEditorScreen.js'
import { TemplateListScreen } from '../screens/templates/TemplateListScreen.js'
import { TrackEditorScreen } from '../screens/tracks/TrackEditorScreen.js'
import { TrackListScreen } from '../screens/tracks/TrackListScreen.js'
import { AppShell } from './AppShell.js'
import { NotFound } from './NotFound.js'

/**
 * The route map (T-201).
 *
 * Every path is a real URL, not app state, so each one is bookmarkable and
 * survives a hard refresh — which depends on the SPA fallback in T-603
 * rewriting unknown paths to `index.html` rather than returning a 404.
 *
 * Exported as data rather than JSX so the tests can assert the map itself.
 */
export const routes: RouteObject[] = [
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <HomeScreen /> },
      { path: 'log', element: <EntryFormScreen /> },
      { path: 'log/:templateId', element: <EntryFormScreen /> },
      { path: 'timeline', element: <TimelineScreen /> },
      { path: 'timeline/:id', element: <EntryDetailScreen /> },
      { path: 'tags', element: <TagsScreen /> },
      { path: 'insights', element: <InsightsScreen /> },
      { path: 'tracks', element: <TrackListScreen /> },
      // `new` before `:id` is not required by the router — a literal segment
      // wins over a dynamic one — but the editor still reads the param, and
      // treating "new" as an id would send it looking for a track called new.
      { path: 'tracks/new', element: <TrackEditorScreen /> },
      { path: 'tracks/:id', element: <TrackEditorScreen /> },
      { path: 'templates', element: <TemplateListScreen /> },
      { path: 'templates/new', element: <TemplateEditorScreen /> },
      { path: 'templates/:id', element: <TemplateEditorScreen /> },
      { path: 'export', element: <ExportScreen /> },
      { path: 'backup', element: <BackupScreen /> },
      { path: 'report', element: <ReportScreen /> },
      { path: 'settings', element: <SettingsScreen /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]
